import React, { Suspense, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { Global404, NotFound, Route404 } from '@saviynt/common';
import { OverlayProvider } from '@saviynt/design-system';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import LocalizedWrapper from '../components/LandingPage/LocalizedWrapper';
import MfaProvider from '../components/MfaModal/MfaProvider';
import { JITA_REQUEST_BASE_URL, REQUEST_BASE_URL } from '../misc/constants';
import { clearSelectedRoles } from '../store/actions/bulkRoleSelectAction';
import { clearLandingPageFilters } from '../store/actions/landingPageFiltersAction';

import LandingPage from './LandingPage/LandingPage';
import CheckOutCredential from './ModalPages/CheckOutCredential';
import CheckOutRole from './ModalPages/CheckOutRole';
import ConnectToSession from './ModalPages/ConnectToSession';

const queryClient = new QueryClient();

function Routes() {
  const dispatch = useDispatch();

  const allowedRoutes = {
    staticRoutes: [
      REQUEST_BASE_URL,
      JITA_REQUEST_BASE_URL,
      `${REQUEST_BASE_URL}/check-out-credential`,
      `${REQUEST_BASE_URL}/check-out-credential`,
      `${REQUEST_BASE_URL}/connect-to-session`,
      `${REQUEST_BASE_URL}/check-out-role`,
      `${REQUEST_BASE_URL}/launch/:launchId`,
    ],
    dynamicRoutes: [],
  };

  // Clear selected roles and filters when component unmounts
  useEffect(
    () => () => {
      dispatch(clearSelectedRoles());
      dispatch(clearLandingPageFilters());
    },
    []
  );

  return (
    <div data-testid='route-container'>
      <LocalizedWrapper>
        <OverlayProvider>
          <QueryClientProvider client={queryClient}>
            <MfaProvider>
              <Suspense key='PAM' fallback={() => {}}>
                <Route404
                  routes={allowedRoutes}
                  render={(path) => <Global404 path={path} />}>
                  <Switch>
                    <>
                      <Route
                        exact
                        path={REQUEST_BASE_URL}
                        component={LandingPage}
                      />
                      <Route
                        exact
                        path={`${REQUEST_BASE_URL}/check-out-credential`}
                        component={CheckOutCredential}
                      />
                      <Route
                        exact
                        path={`${REQUEST_BASE_URL}/connect-to-session`}
                        component={ConnectToSession}
                      />
                      <Route
                        exact
                        path={`${REQUEST_BASE_URL}/check-out-role`}
                        component={CheckOutRole}
                      />
                      <Route
                        exact
                        path={JITA_REQUEST_BASE_URL}
                        component={LandingPage}
                      />
                    </>
                    <Route component={NotFound} />
                  </Switch>
                </Route404>
              </Suspense>
            </MfaProvider>
          </QueryClientProvider>
        </OverlayProvider>
      </LocalizedWrapper>
    </div>
  );
}

export default Routes;
